// removed by extract-text-webpack-plugin
module.exports = {"header":"ActivityList--header--3WVAwqbp","columnLabel":"ActivityList--columnLabel--2gxIPrxE","noDataMsg":"ActivityList--noDataMsg--3N4beR_u","activityAvatar":"ActivityList--activityAvatar--XKigOeic","activityListTile":"ActivityList--activityListTile--1dXMAche","activityDetails":"ActivityList--activityDetails--2hGNnEwQ","avatarContainer":"ActivityList--avatarContainer--3UJ0WIvk","avatarContainerHide":"ActivityList--avatarContainerHide--1r_ZvhM_","action":"ActivityList--action--3Njl2wZe"};


//////////////////
// WEBPACK FOOTER
// ./src/App/account/components/ActivitiesPage/ActivityList.css
// module id = 498
// module chunks = 2